module.exports = __webpack_public_path__ + "img/store_IG.870428a8.svg";